import { MeterType } from "@next-platform/packages-ts-types";
/**
 * Chip text for one combined-rule condition: value comparisons stay symbolic
 * (`Affection >= 50`), `day>=`/`day<=` read as story days, and `tod_is` names the
 * referenced time-of-day band (or falls back to its index).
 */
export default function formatCombinedRuleCondition({ condition, meters, translate, }) {
    const meter = meters.find((candidate) => candidate.id === condition.meter_id);
    const label = meter?.label ?? condition.meter_id;
    if (condition.op === "tod_is") {
        const band = meter?.type === MeterType.CLOCK ? meter.tod_levels[condition.level_index] : undefined;
        const bandLabel = band?.label ?? `#${condition.level_index}`;
        return translate("rulebook:profile.combined.todIs", { meter: label, band: bandLabel });
    }
    if (condition.op === "day>=") {
        return translate("rulebook:profile.combined.dayMin", { day: condition.value });
    }
    if (condition.op === "day<=") {
        return translate("rulebook:profile.combined.dayMax", { day: condition.value });
    }
    return `${label} ${condition.op} ${condition.value}`;
}
